/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockedDayDto } from '../../models/blocked-day-dto';
import { CreateBlockedDayForm } from '../../models/create-blocked-day-form';

export interface CreateBlockedDay$Params {
      body: CreateBlockedDayForm
}

export function createBlockedDay(http: HttpClient, rootUrl: string, params: CreateBlockedDay$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BlockedDayDto>>> {
  const rb = new RequestBuilder(rootUrl, createBlockedDay.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BlockedDayDto>>;
    })
  );
}

createBlockedDay.PATH = '/blocked-days';
